import { makeStyles } from "tss-react/mui"

export const useStyles = makeStyles()(({ transitions, palette, mixins }) => ({
  switch: {
    width: "35px",
    height: "20px",
    padding: 0,
    overflow: "initial",
    "& .MuiSwitch-switchBase": {
      padding: 0,
      margin: 2,
      transitionDuration: "300ms",
      "&.Mui-checked": {
        transform: "translateX(16px)",
        color: palette.common.white,
        "& + .MuiSwitch-track": {
          backgroundColor: palette.secondary[500],
          opacity: 1,
          border: 0
        },
        "&.Mui-disabled + .MuiSwitch-track": {
          backgroundColor: palette.secondary[200]
        },
        "&.Mui-disabled .MuiSwitch-thumb": {
          backgroundColor: palette.common.white
        }
      },
      "&.Mui-focusVisible + .MuiSwitch-track": {
        // a11y: box-shadow ring, not the border-based outline variant — the checked
        // track sets border:0, so a borderColor-only ring would vanish when checked.
        ...mixins.focusRing.ring
      },
      "&.Mui-disabled .MuiSwitch-thumb": {
        backgroundColor: palette.common.white
      },
      "&.Mui-disabled + .MuiSwitch-track": {
        opacity: 1,
        backgroundColor: palette.primary[200]
      }
    },
    "& .MuiSwitch-thumb": {
      boxSizing: "border-box",
      width: "15px",
      height: "15px"
    },
    "& .MuiSwitch-track": {
      borderRadius: 26 / 2,
      border: `1px solid transparent`,
      backgroundColor: palette.primary[500],
      opacity: 1,
      transition: transitions.create(["background-color"], {
        duration: 500
      })
    }
  }
}))
